import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

function Accessibility() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow bg-gray-50 py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-6">Accessibility Statement</h1>
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-lg text-gray-700 mb-6">
              BoardVoyage is committed to ensuring digital accessibility for people with disabilities.
            </p>
            <div className="space-y-6">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Our Commitment</h2>
                <p className="text-gray-600">
                  We are continually improving the user experience for everyone and applying relevant accessibility standards.
                </p>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Accessibility Features</h2>
                <ul className="list-disc list-inside text-gray-600 space-y-2">
                  <li>Keyboard navigation support</li>
                  <li>Screen reader compatibility</li>
                  <li>Clear and consistent navigation</li>
                  <li>Alternative text for images</li>
                  <li>Sufficient color contrast</li>
                </ul>
              </div>
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 mb-3">Feedback</h2>
                <p className="text-gray-600">
                  We welcome feedback on the accessibility of BoardVoyage. If you encounter accessibility barriers, please contact us so we can assist you.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Accessibility;
